import { useToast } from '@chakra-ui/react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import {
  useRequestConfirmAllOrdersMutation,
  useVerifyConfirmAllOrdersMutation,
} from 'rtkQuery/sharespro/queries/orders';
import { useFetchProfileQuery } from 'rtkQuery/sharespro/queries/profile';

import PhoneConfirmationModal from 'presentation/components/shared/modals/PhoneConfirmationModal';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

const ConfirmAllOrdersModal: FC<Props> = ({ isOpen, onClose }) => {
  const { data } = useFetchProfileQuery();

  const [verifyOtp, { isLoading }] = useVerifyConfirmAllOrdersMutation();

  const toast = useToast();

  const { t } = useTranslation();

  const [requestOrderConfirmation, { isLoading: newCodeRequesting }] =
    useRequestConfirmAllOrdersMutation();

  return (
    <PhoneConfirmationModal
      isOpen={isOpen}
      onClose={onClose}
      title={t('orderConfirmation')}
      text={t('codeHasBeenSentToNumber')}
      phoneNumber={data?.phone ?? null}
      onSubmit={async (values) => {
        await verifyOtp(values.code)
          .unwrap()
          .then(() => {
            onClose();
            toast({
              description: t('allOrdersHaveBeenApproved'),
              status: 'success',
              position: 'top-right',
              isClosable: true,
            });
          });
      }}
      otpVerifying={isLoading}
      onSendNewCode={async () => {
        await requestOrderConfirmation().unwrap();

        return 1;
      }}
      newCodeRequesting={newCodeRequesting}
    />
  );
};

export default ConfirmAllOrdersModal;
